export default __webpack_public_path__ + "92f2d2eae6860a0fd6c190724268c8c2.png";